import { render, staticRenderFns } from "./Godishni.vue?vue&type=template&id=d20fdee0"
import script from "./Godishni.vue?vue&type=script&lang=js"
export * from "./Godishni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports